import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

/**
 * 計算每週一到週五訂單數量
 * @param {Array} ordersData - 訂單資料
 * @param {Object} weekRange - { start: Date, end: Date }
 * @returns {Array} - [週一, 週二, 週三, 週四, 週五] 訂單數量
 */
export function getWeekOrdersCount(ordersData, weekRange) {
  const counts = [0, 0, 0, 0, 0]; // 週一～週五

  ordersData.forEach(order => {
    const date = dayjs(order.deliveryDate);
    if (date.isBetween(dayjs(weekRange.start).subtract(1, 'day'), dayjs(weekRange.end).add(1, 'day'))) {
      const weekday = date.day(); // 0=日, 1=一, ..., 6=六
      if (weekday >= 1 && weekday <= 5) {
        counts[weekday - 1] += 1;
      }
    }
  });

  return counts;
}

/**
 * 計算本月每天訂單數量
 * @param {Array} ordersData - 訂單資料
 * @param {Number} year - 指定年份
 * @param {Number} month - 指定月份 (1-12)
 * @returns {Array} - [第1天, 第2天, ..., 第N天] 訂單數量
 */
export function getMonthOrdersCount(ordersData, year, month) {
  const start = dayjs(`${year}-${month}-01`);
  const end = start.endOf('month');
  const daysInMonth = start.daysInMonth();

  const counts = Array(daysInMonth).fill(0);

  ordersData.forEach(order => {
    const date = dayjs(order.deliveryDate);
    if (date.isBetween(start.subtract(1, 'day'), end.add(1, 'day'))) {
      const dayOfMonth = date.date(); // 幾號 (1～daysInMonth)
      counts[dayOfMonth - 1] += 1;
    }
  });

  return counts;
}

/**
 * 計算本年每月訂單數量
 * @param {Array} ordersData - 訂單資料
 * @param {Number} year - 指定年份
 * @returns {Array} - [1月, 2月, ..., 12月] 訂單數量
 */
export function getYearOrdersCount(ordersData, year) {
  const start = dayjs(`${year}-01-01`);
  const end = start.endOf('year');

  const counts = Array(12).fill(0);

  ordersData.forEach(order => {
    const date = dayjs(order.deliveryDate);
    if (date.isBetween(start.subtract(1, 'day'), end.add(1, 'day'))) {
      const monthIndex = date.month(); // 0=一月, ..., 11=十二月
      counts[monthIndex] += 1;
    }
  });

  return counts;
}
